module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "70px",
      "height": "70px",
      "viewBox": "0 0 70 70",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    attrs: {
      "id": "Symbols",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "ICON:-Temperment",
      "fill": "#050C14"
    }
  }, [_c('path', {
    attrs: {
      "d": "M60,55 C58.5441081,55 11.7993164,55 10,55 C10,43.8366699 14.1764427,34.2923521 24.1662077,30.4365191 C23.1158447,29.284668 20.0156657,25.7830811 20.0156657,20.0223796 C20.0156657,13.3143916 25.6017125,5 35,5 C43.7435452,5 49.9338786,12.3539225 49.9338786,20.0223796 C49.9338786,26.9734701 45.8765671,30 45.8765671,30.4549123 C55.8335853,34.3226378 60,43.8543791 60,55 Z M35,50 C40.5555556,46.9590901 43.3333333,43.8522984 43.3333333,40.6796247 C43.3333333,35.9206142 39.6023729,34.1729476 35,37.6900703 C30.3976271,34.1729476 26.6666667,35.9206142 26.6666667,40.6796247 C26.6666667,43.8522984 29.4444444,46.9590901 35,50 Z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Line",
      "x": "0",
      "y": "67",
      "width": "70",
      "height": "3"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-992db03c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/svg/temperment.vue
// module id = 651
// module chunks = 1